export const getEarText = (ear: string | undefined | null) => {
  if (ear === "L") return "Left";
  if (ear === "R") return "Right";
  return "--";
};
